import styled from 'styled-components'

import { color, spacing } from '../../themes'
import { Grid } from '../Grid'

export const TopBorderGrid = styled(Grid)`
  border-top: 1px solid ${color('gray.03')};
  padding-top: ${spacing(4)};
  margin-top: ${spacing(4)};
  width: 250px;
  gap: 0 ${spacing(6)};
`
